import React from 'react'
import PropTypes from 'prop-types'

import Font from '@cred/react-font'
import logo from '@cred/global-assets/images/logos/credible/logo-blue.svg'

import styles from './styles.module.scss'

const PoweredBy = ({ className, useFontAttrs = false, color = 'lighter', type = 'bodySmall' }) => (
  <div className={className}>
    <Font type={type} color={color} className={useFontAttrs ? '' : styles.text}>
      Powered by&nbsp;
      <img src={logo} className={styles.logo} alt="Credible" />
    </Font>
  </div>
)

PoweredBy.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  useFontAttrs: PropTypes.bool,
}
export default PoweredBy
